module.exports = __webpack_public_path__ + "static/media/Image03.11017622.png";